import { HeroSection } from "./Hero";
import { PricingToggle } from "./PricingToggle";
import { FeaturesGrid } from "./FeatureGrid";
import { FAQSection } from "./FAQSection";
import { CallToAction } from "./CallToAction";
import RevealOnScroll from "@/components/ui/RevelOnScroll";
import { SEO } from "@/components/common/SEO";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "VaWeNa Pricing",
  "description": "Simple, transparent pricing for real estate investors. WealthScope $9.99/mo, PortfolioIQ $29.99/mo, Bundle $34.99/mo. 17% off annual plans. 14-day free trial.",
  "url": "https://vawena.ai/pricing",
};

const PricingPage = () => {
  return (
    <>
      <SEO
        title="Pricing — WealthScope & PortfolioIQ Plans for Real Estate Investors"
        description="WealthScope $9.99/mo, PortfolioIQ $29.99/mo, Bundle $34.99/mo. Save 17% on any plan with annual billing. 14-day free trial — cancel anytime."
        canonical="/pricing"
        schema={schema}
      />
      <div className="w-full min-h-screen dark:bg-[#020D30] bg-[#f0f4ff]">
        <HeroSection />

        <RevealOnScroll direction="up">
          <PricingToggle />
        </RevealOnScroll>

        <RevealOnScroll direction="up">
          <FeaturesGrid />
        </RevealOnScroll>

        <RevealOnScroll direction="up">
          <FAQSection />
        </RevealOnScroll>

        <RevealOnScroll direction="up">
          <CallToAction />
        </RevealOnScroll>
      </div>
    </>
  );
};

export default PricingPage;
